module.exports = __webpack_public_path__ + "img/GIS_ESC_rights.e34169ac.svg";